import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpError, Promocode, PromocodeUsage } from '@rd/types';
import { Observable } from 'rxjs';
import * as actions from '../store/actions/cashback.actions';
import {
  getCashbackError,
  getCashbackFail,
  getCashbackFormState,
  getCashbackLoading,
  getCashbackSuccess,
} from '../store/selectors/cashback.selectors';
import { CashbackFormData } from '../types';

@Injectable({
  providedIn: 'root',
})
export class CashbackFacade {
  constructor(private store: Store) {}

  cashbackForm$ = this.store.select(getCashbackFormState);

  cashbackLoading$: Observable<boolean> = this.store.select(getCashbackLoading);

  cashbackSuccess$: Observable<boolean> = this.store.select(getCashbackSuccess);

  cashbackFail$: Observable<boolean> = this.store.select(getCashbackFail);

  cashbackError$: Observable<HttpError | null> =
    this.store.select(getCashbackError);

  submitCashbackForm(data: {
    loyaltyProgramId: string;
    formData: CashbackFormData;
  }): void {
    this.store.dispatch(actions.SubmitCashbackForm(data));
  }

  submitCashback(data: {
    loyaltyProgramId: string;
    formData: CashbackFormData;
    promocode?: Promocode;
    promocodeUsage?: PromocodeUsage;
  }): void {
    this.store.dispatch(actions.SubmitCashback(data));
  }

  clearCashbackError() {
    this.store.dispatch(actions.ClearCashbackError());
  }
}
